<template>
    <div>
        <v-dialog
            v-model="display"
            persistent
            width="500">
            <v-card flat>
                <v-card-title>
                    {{ $t('search_by') }}
                </v-card-title>
                <v-card-text>
                    <v-form 
                        v-model="valid"
                        ref="form"
                        >
                        <v-menu
                            ref="from"
                            v-model="from"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="form.from"
                                :label="$t('date')"
                                append-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                            </template>
                            <v-date-picker v-model="form.from" @input="from = false" no-title scrollable>
                            </v-date-picker>
                        </v-menu>
                        <v-menu
                            ref="to"
                            v-model="to"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="form.to"
                                :label="$t('validity_date')"
                                append-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                            </template>
                            <v-date-picker v-model="form.to" @input="to = false" no-title scrollable>
                            </v-date-picker>
                        </v-menu>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="submit" :disabled="form.to < form.from" text>
                        {{ $t('search') }}
                    </v-btn>
                    <v-btn @click="close" text>
                        {{ $t('cancel_btn') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
export default {
    name: "SearchBy",
    components: {
        
    },
    data() {
        return {
            display: false,
            valid:false,
            from:false,
            to:false,
            form: {
                from: new Date().toISOString().substr(0, 10),
                to: new Date().toISOString().substr(0, 10),
            } 
        }
    },
    computed: {
        
    },
    methods: {
        open() {
            this.display = true;
        },
        submit() {
            this.$emit('search', this.form)
            this.close();
        },
        close() {
            this.display = false;
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
        }
    }
}
</script>